import { render, staticRenderFns } from "./InvoiceTotalsTable.vue?vue&type=template&id=1ac9fb1d&scoped=true"
import script from "./InvoiceTotalsTable.vue?vue&type=script&lang=js"
export * from "./InvoiceTotalsTable.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTotalsTable.vue?vue&type=style&index=0&id=1ac9fb1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac9fb1d",
  null
  
)

export default component.exports